'use strict';

const auth = require('../../../services/client/auth');
const gtm = require('../../../services/client/gtm');
const { getSiteBase } = require('../../../services/client/page');
const { getSailthruProfileFromAuth, updateUser } = require('../../../services/client/newsletterz');
const {
  RECAPTCHA_SITE_KEY,
} = require('../../subscription-multi-step-container/services/constants');

/**
 * Auto opt-in the user in the sailthru lists if they're not already and haven't opted in before.
 *
 * @param {Object} profile - The user profile.
 * @return {void}
 */
function autoOptInUserOnPostSavedAuth(profile) {
  if (!profile.isAuthenticated) return;
  // the user saved a product during the authentication process and landed in the account page
  // GA events were fired in the account page
  const postAuthResultFromUrl = auth.getPostAuthenticationResultFromUrl() === 'saved-product';
  // the user saved a product during the authentication process and landed in this article page
  // firing the GA events
  const postAuthResultFromCookie = auth.productSaveEventFromCookie();
  const isStrategist = getSiteBase().includes('strategist');

  // auto opt-in the user in the sailthru lists if they're not already and haven't opted in before
  if (isStrategist && (postAuthResultFromUrl || postAuthResultFromCookie)) {
    // remove the post-auth result from the url to prevent running this method again on page refresh
    auth.removePostAuthenticationResultFromUrl();

    const sailthru = getSailthruProfileFromAuth();
    const userInfo = {
      email: auth.getEmail(),
      event: 'newsletterSubmit',
      lists: {
        salenotifs: true,
        salenotifsoptinever: true
      },
      vars: {
        source_salenotifs: 'auth',
        signuppage_salenotifs: window.location.href,
        source_salenotifsoptinever: 'auth',
        signuppage_salenotifsoptinever: window.location.href
      }
    };
    const eventData = {
      event: 'product_save_opt_in_notification',
      ['product_save_opt_in_notification']: {
        position: 'product_save_auth'
      }
    };

    if (sailthru?.lists) {
      const isOptedIn = sailthru.lists.salenotifs;
      const hasEverOptedIn = sailthru.lists.has_opted_in_sale_notifs;

      // opt in the user if they're not already and haven't opted in before, and send GA event
      if (!isOptedIn && !hasEverOptedIn) {
        // opt in the user, and send GA event
        updateUser(RECAPTCHA_SITE_KEY, userInfo)
          .then(() => auth.fetchUserProfile(true))
          .then(() => gtm.reportNow(eventData))
          .catch((e) => {
            console.error(`Error opting in the user on post-auth product saving: ${e.message}`);
          });
      }
    }
  }
}

module.exports = {
  autoOptInUserOnPostSavedAuth
};
